export enum Languages {
  ENGLISH = 'en',
  HUNGARIAN = 'hu',
  FRENCH = 'fr',
  SPAIN = 'es',
  // ITALIAN = 'it',
  // RUSSIAN = 'ru',
  // SLOVAK = 'sk',
}
